import { Component } from '@angular/core';

@Component({
  selector: 'app-error-icon',
  standalone: true,
  imports: [],
  template: `
    <svg
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      width="1024"
      height="1024"
      viewBox="0 0 1024 1024"
      class="h-5 w-5 text-danger">
      <g id="icomoon-ignore"></g>
      <path
        class="fill-current"
        fill-opacity="0.1"
        fill="currentColor"
        d="M512.004 998.404c-91.982 0-181.897-27.277-258.377-78.379s-136.089-123.733-171.288-208.717c-35.2-84.979-44.41-178.487-26.465-268.701s62.238-173.081 127.279-238.121c65.041-65.041 147.907-109.334 238.121-127.279s183.722-8.735 268.701 26.465c84.983 35.2 157.615 94.808 208.717 171.288s78.379 166.395 78.379 258.377c-0.115 123.307-49.148 241.532-136.341 328.725s-205.419 136.226-328.725 136.341z"></path>
      <path
        fill="currentColor"
        d="M512 1002.666c-92.825 0-183.566-27.524-260.748-79.095s-137.337-124.873-172.86-210.633c-35.523-85.76-44.817-180.126-26.708-271.168s62.809-174.669 128.446-240.306c65.638-65.638 149.265-110.337 240.306-128.446s185.408-8.815 271.168 26.708c85.76 35.523 159.061 95.678 210.633 172.86s79.095 167.922 79.095 260.748c-0.115 124.442-49.6 243.75-137.591 331.742s-207.3 137.476-331.742 137.591zM512 129.488c-79.872 0-157.952 23.685-224.364 68.060s-118.174 107.447-148.74 181.24c-30.566 73.794-38.564 154.993-22.981 233.333 15.582 78.336 54.045 150.293 110.524 206.775 56.479 56.478 128.437 94.938 206.777 110.519 78.336 15.586 159.535 7.586 233.327-22.98 73.796-30.566 136.866-82.325 181.244-148.74 44.373-66.411 68.058-144.491 68.058-224.363-0.115-107.071-42.701-209.723-118.409-285.434-75.712-75.711-178.364-118.295-285.436-118.411zM512.004 594.457c11.575 0 22.682-4.599 30.869-12.787s12.787-19.294 12.787-30.874v-203.45c0-11.579-4.599-22.684-12.787-30.871s-19.294-12.787-30.869-12.787c-11.58 0-22.686 4.599-30.874 12.787s-12.787 19.293-12.787 30.871v203.45c0 11.58 4.599 22.686 12.787 30.874s19.294 12.787 30.874 12.787zM566.575 708.386c0 30.14-24.435 54.575-54.575 54.575s-54.575-24.435-54.575-54.575c0-30.14 24.435-54.575 54.575-54.575s54.575 24.435 54.575 54.575z"></path>
    </svg>
  `,
})
export class ErrorIconComponent {}
